/**
 * Logger utility for frontend
 *
 * Levels:
 * - DEBUG (0): Development only, disabled in production
 * - INFO (1): Important events, always shown
 * - WARN (2): Warnings, always shown
 * - ERROR (3): Errors only, always shown
 *
 * Log level is configured in config.ts and cannot be changed at runtime.
 *
 * Usage:
 * Logger.debug('CacheManager', 'Processing %d items', count);
 * Logger.info('ApiService', 'Login successful');
 * Logger.error('ApiService', 'Network error: %s', error.message);
 * Logger.warn('SW', 'Timeout detected');
 */

export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3
}

// Import loggerLevel from config (numbers: 0=DEBUG, 1=INFO, 2=WARN, 3=ERROR)
import { loggerLevel } from '../config';

export class Logger {
  /**
   * Debug level - Development only
   */
  static debug(prefix: string, message: string, ...args: any[]): void {
    if (loggerLevel <= LogLevel.DEBUG) {
      console.log(`[${prefix}] ${message}`, ...args);
    }
  }

  /**
   * Info level - Important events
   */
  static info(prefix: string, message: string, ...args: any[]): void {
    if (loggerLevel <= LogLevel.INFO) {
      console.log(`[${prefix}] ${message}`, ...args);
    }
  }

  /**
   * Warn level - Warnings and issues
   */
  static warn(prefix: string, message: string, ...args: any[]): void {
    if (loggerLevel <= LogLevel.WARN) {
      console.warn(`[${prefix}] ${message}`, ...args);
    }
  }

  /**
   * Error level - Errors (always shown)
   */
  static error(prefix: string, message: string, ...args: any[]): void {
    console.error(`[${prefix}] ${message}`, ...args);
  }
}
